var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { useMemo } from "react";
import classnames from "classnames";
import TextareaItem from "../textarea-item";
import FormField from "../a-form-field";
import "./style/index.less";
const TextAreaFormItem = (_a) => {
    var { label = "备注", itemName = "remarks", form, required = false, rules = [], fieldOptions = {} } = _a, rest = __rest(_a, ["label", "itemName", "form", "required", "rules", "fieldOptions"]);
    const { getFieldProps, getFieldError } = form;
    const fieldError = useMemo(() => {
        const errors = getFieldError(itemName);
        if (errors && errors.length > 0) {
            return errors.join(",");
        }
        return null;
    }, [itemName, getFieldError(itemName)]);
    return (<FormField form={form} extraItem={<div className={classnames("ppx-textarea-item")}>
          <div className={classnames("remark-title", { required })}>
            {label}
          </div>
          <div className={classnames("remark")}>
            <TextareaItem {...rest} placeholder={`请输入${label}`} {...getFieldProps(itemName, Object.assign({ rules: [
            {
                required,
                message: `请输入${label}`,
            },
            ...rules,
        ] }, fieldOptions))} rows={3}/>
          </div>
          {fieldError && (<div className={classnames("error")}>{fieldError}</div>)}
        </div>}/>);
};
export default TextAreaFormItem;
